import React, { useEffect } from "react";
import Contact from "./Contact";

// Thin wrapper so routing still imports ContactPage; reuses Contact component.
const ContactPage = () => {
    useEffect(() => {
        document.title = "Contact — Kayleigh Schlupp";
    }, []);

    return <Contact isStandalone={true} />;
};

export default ContactPage;
